module.exports = __webpack_public_path__ + "static/media/reedCBW1028.74dd0e98.ico";